import { ModelClass }  from '@mathquis/modelx/lib/types/collection';
import ApiModel        from '@widesk-core/models/ApiModel';
import useCollection   from '@widesk-core/hooks/useCollection';
import PagedCollection from '@widesk-core/models/PagedCollection';

export default function <M extends ModelClass<ApiModel>>(modelClass: M, fetch = false) {
	return useCollection(() => new PagedCollection(modelClass), fetch) as PagedCollection<InstanceType<M>>;
}
